export type CheckoutEventContext = {
  /** Meta/browser event id used for Pixel/CAPI dedup and Razorpay-note fallback. */
  event_id: string;
  /** Meta Pixel option uses camelCase while backend/API payloads use snake_case. */
  eventId: string;
};

declare global {
  interface Window {
    fbq?: (
      event: string,
      name: string,
      params?: Record<string, unknown>,
      options?: { eventID?: string }
    ) => void;
  }
}

export function createCheckoutEventContext(): CheckoutEventContext {
  const eventId = newCheckoutEventId();
  return { event_id: eventId, eventId };
}

export function trackMetaPurchase(checkoutEvent: CheckoutEventContext, valueInr: number): void {
  if (typeof window === "undefined" || !window.fbq) return;
  window.fbq(
    "track",
    "Purchase",
    { value: valueInr, currency: "INR" },
    { eventID: checkoutEvent.eventId }
  );
}

function newCheckoutEventId(): string {
  const randomUUID = globalThis.crypto?.randomUUID?.bind(globalThis.crypto);
  if (randomUUID) return randomUUID();
  return `checkout_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
